export default __webpack_public_path__ + "static/media/higher_icon_calendar.19c8eef4.svg";